import React from 'react';
import ImprintBlock from "./util/ImprintBlock";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Datenschutz = ({

}) => {
	return (
		<Row>
			<Col>
				<div className = {'datenschutz'}>
					<ImprintBlock
						headline = {'Datenschutz'}
						text = {
							'Die Betreiber dieser Seiten (Gerd Xeller, Drosselweg 7, 88471 Laupheim) nehmen den Schutz Ihrer persönlichen ' +
							'Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen ' +
							'Datenschutzvorschriften sowie dieser Datenschutzerklärung.' +

							'\n\nDie Nutzung unserer Website ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren ' +
							'Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, ' +
							'soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an ' +
							'Dritte weitergegeben.' +

							'\n\nWir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) ' +
							'Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.'}/>
					<ImprintBlock
						headline = {'Cookies'}
						text = {
							'Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an ' +
							'und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu ' +
							'machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.' +

							'\n\nDie meisten der von uns verwendeten Cookies sind so genannte „Session-Cookies“. Sie werden nach Ende Ihres ' +
							'Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Diese ' +
							'Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.' +

							'\n\nSie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur ' +
							'im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das ' +
							'automatische Löschen der Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies kann ' +
							'die Funktionalität dieser Website eingeschränkt sein.'}/>
					<ImprintBlock
						headline = {'Server-Log-Files'}
						text = {
							(
								<>
									{'Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log Files, die Ihr ' +
										'Browser automatisch an uns übermittelt. Dies sind:'}
									<ul>
										<li>
											{'Browsertyp und Browserversion'}
										</li>
										<li>
											{'Verwendetes Betriebssystem'}
										</li>
										<li>
											{'Referrer URL'}
										</li>
										<li>
											{'Hostname des zugreifenden Rechners'}
										</li>
										<li>
											{'Uhrzeit der Serveranfrage'}
										</li>
									</ul>
									{'Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen ' +
										'Datenquellen wird nicht vorgenommen. Wir behalten uns vor, diese Daten nachträglich zu prüfen, wenn ' +
										'uns konkrete Anhaltspunkte für eine rechtswidrige Nutzung bekannt werden.'}
								</>
							)
						}/>
					<ImprintBlock
						headline = {'SSL-Verschlüsselung'}
						text = {
							'Diese Seite kann aus Gründen der Sicherheit und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel ' +
							'der Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-Verschlüsselung nutzen. Eine verschlüsselte ' +
							'Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf „https://“ wechselt und an dem ' +
							'Schloss-Symbol in Ihrer Browserzeile.'
						}/>
					<ImprintBlock
						headline = {'Recht auf Auskunft, Löschung, Sperrung'}
						text = {
							'Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren ' +
							'Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung ' +
							'dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit unter der ' +
							'im Impressum angegebenen Adresse an uns wenden oder schreiben Sie uns eine E-Mail an: info(at)xeller.info'
						}/>
				</div>
			</Col>
		</Row>
	);
};

export default Datenschutz;
